import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dicts } from "./translations";
import { api } from "./api";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("candle_lang") : null;
    if (stored === "fr" || stored === "en") return stored;
    if (typeof navigator !== "undefined" && navigator.language?.startsWith("fr")) return "fr";
    return "en";
  });

  const setLang = useCallback((next, opts = {}) => {
    if (next !== "fr" && next !== "en") return;
    setLangState(next);
    if (typeof window !== "undefined") localStorage.setItem("candle_lang", next);
    if (opts.persist) {
      api.put("/user/preferences", { language: next }).catch(() => {});
    }
  }, []);

  const t = useCallback((key) => {
    const dict = dicts[lang] || dicts.en;
    return dict[key] ?? dicts.en[key] ?? key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
